import { render, staticRenderFns } from "./KycStatus.vue?vue&type=template&id=aefc7e74&scoped=true"
import script from "./KycStatus.vue?vue&type=script&lang=js"
export * from "./KycStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aefc7e74",
  null
  
)

export default component.exports